import { useMemo } from 'react';
import type { BiLogger } from '@wix/cli-telemetry';
import { useBiLogger } from '@wix/cli-telemetry-react';
import {
  wixCliAction,
  wixCliAppFlowStepsAnswers,
} from '@wix/bi-logger-dev-tools-data/v2';

function siteSelectorBiEvents(biLogger: BiLogger) {
  return {
    cliAction: ({
      question,
      action,
      key,
      additionalInfo,
    }: {
      question: string;
      action: string;
      key: string;
      additionalInfo?: Record<string, unknown>;
    }) => {
      void biLogger.report(
        wixCliAction({
          question,
          action,
          key,
          additionalInfo: JSON.stringify(additionalInfo),
        })
      );
    },
    cliFlowStepAnswered: ({
      question,
      answer,
      additionalInfo,
    }: {
      question: string;
      answer: string;
      additionalInfo?: Record<string, unknown>;
    }) => {
      void biLogger.report(
        wixCliAppFlowStepsAnswers({
          question,
          answer,
          additionalInfo: JSON.stringify(additionalInfo),
        })
      );
    },
  };
}

export function useSiteSelectorBi() {
  const biLogger = useBiLogger();
  return useMemo(() => siteSelectorBiEvents(biLogger), [biLogger]);
}
